// ===============================
// RESET VARIANTS
// ===============================
document.querySelectorAll('variant-selects input[type="radio"]').forEach(radio => {
  radio.checked = false;
  radio.removeAttribute('checked');
});

// ===============================
// GLOBAL STATE
// ===============================
let lastFocusedInput = null;
let lastInputWasKeyboard = false;

// Track keyboard only when typing inside the silicone inputs
document.addEventListener('keydown', (e) => {
  const t = e.target;
  if (t && t.tagName === 'INPUT' && (t.id.startsWith('silicone-text') || t.id.startsWith('fabric-text') || t.id.startsWith('qr-text-input'))
) {
    lastInputWasKeyboard = true;
    console.log("⌨️ Keyboard input detected on silicone field");
    const max = parseInt(t.getAttribute("maxlength"), 10) || 16;
    if (t.value.length >= max) {
      console.log("🚫 Max reached after icon insert: ", t);
      t.style.color = "red";
      setTimeout(() => { t.style.color = ""; }, 200);
    }
  }
});

// Track mouse down only on silicone inputs
document.addEventListener('mousedown', (e) => {
  const t = e.target;
  if (t && t.tagName === 'INPUT' && (t.id.startsWith('silicone-text') || t.id.startsWith('fabric-text') || t.id.startsWith('qr-text-input'))
) {
    lastInputWasKeyboard = false;
  }
});

// Track focused input globally, but only save it if it's a silicone field
document.addEventListener('focusin', (e) => {
  const t = e.target;
  if (t && t.tagName === 'INPUT' && (t.id.startsWith('silicone-text') || t.id.startsWith('fabric-text') || t.id.startsWith('qr-text-input'))
) {
    lastFocusedInput = t;
    console.log("🎯 Focused input:", t.id);
  }
});

// Track clicked input globally, but only save it if it's a silicone field
document.addEventListener('click', (e) => {
  const t = e.target;
  if (t && t.tagName === 'INPUT' && (t.id.startsWith('silicone-text') || t.id.startsWith('fabric-text') || t.id.startsWith('qr-text-input'))
) {
    lastFocusedInput = t;
    console.log("🖱️ Clicked input:", t.id);
  }
});

// ===============================
// SILICONE INPUTS SETUP
// ===============================
const siliconeInputs = [
  document.getElementById('silicone-text-1'),
  document.getElementById('silicone-text-2'),
  document.getElementById('fabric-text-icons-1-no-qr'),
  document.getElementById('fabric-text-line-1-no-qr'),
  document.getElementById('fabric-text-line-2-no-qr'),
  document.getElementById('fabric-text-line-3-no-qr'),
  document.getElementById('fabric-text-line-4-no-qr'),
  document.getElementById('qr-text-input')
].filter(Boolean);

const siliconeLabels = [
  document.querySelector('label[for="silicone-text-1"]'),
  document.querySelector('label[for="silicone-text-2"]')
].filter(Boolean);

if (siliconeInputs.length > 0) {
  lastFocusedInput = siliconeInputs[0];
  console.log("✅ Default focused input:", lastFocusedInput.id);
}

// ===============================
// CHECK PRODUCT TYPE
// ===============================
function isSiliconeProduct() {
  const mainEl = document.getElementById('MainContent');
  const productTemplate = mainEl?.getAttribute('product-template');
  
  console.log("📦 Current Template:", productTemplate);
  
  // Ab ye Silicone aur Kidscord dono ko accept kare ga
  return productTemplate && (
    productTemplate.startsWith('product.silicone') || 
    productTemplate.startsWith('product.kidscord')
  );
}

// ===============================
// INPUT HANDLER (MAIN LOGIC & SANITIZATION)
// ===============================
function handleSiliconeInput(e) {
  const input = e.target;
  const maxLength = parseInt(input.getAttribute("maxlength"), 10) || 16;
  let text = input.value;
  const originalText = text;

  console.log("✏️ Input event triggered:", text);

  // ===============================
  // 1. SANITIZE (ANSI + STORE ICONS ONLY)
  // ===============================
  
  // A. Greek Homoglyph Swap (Μ -> M)
  const lookalikes = {
    'Α': 'A', 'Β': 'B', 'Ε': 'E', 'Ζ': 'Z', 'Η': 'H', 'Ι': 'I', 
    'Κ': 'K', 'Μ': 'M', 'Ν': 'N', 'Ο': 'O', 'Ρ': 'P', 'Τ': 'T', 
    'Υ': 'Y', 'Χ': 'X'
  };
  text = text.replace(/[ΑΒΕΖΗΙΚΜΝΟΡΤΥΧ]/g, char => lookalikes[char]);

  // B. Build Whitelist of Official Store Icons
  const allowedIcons = new Set();
  document.querySelectorAll('#medical-icons-keyboard button, #fun-icons-keyboard button').forEach(btn => {
    const val = btn.dataset.value || btn.textContent.trim();
    if (val) { for (const char of val) allowedIcons.add(char); }
  });

  // C. Strict Windows-1252 Regex (Tests a single character)
  const win1252Regex = /^[\x00-\xFF\u20AC\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\u017D\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\u017E\u0178]$/;

  // D. Filter the string character by character
  let cleanText = "";
  for (const char of text) {
    if (win1252Regex.test(char) || allowedIcons.has(char)) {
      cleanText += char;
    }
  }

  // E. Apply clean text and show warning if bad characters were removed
  if (cleanText !== originalText) {
    input.value = cleanText;
    input.style.border = "2px solid red";
    setTimeout(() => { input.style.border = ""; }, 2000);
  }

// ===============================
  // 2. SAFE UPPERCASE (OS MENU & KEYBOARD)
  // ===============================
  if (input.classList.contains('force-uppercase')) {
    console.log("🔠 Applying SAFE uppercase logic");
    const start = input.selectionStart;
    const end = input.selectionEnd;
    
    // Matches a-z and safe accented characters (Ä, Ö, Ü, etc.)
    // We EXPLICITLY EXCLUDE characters used for your custom icons (ò, ý, ð, ø, þ, æ, å, ÿ) 
    // so that the icons do not break when inserted.
    const safeUpperRegex = /[a-zàáâãäèéêëìíîïñóôõöùúûüß]/g;
    
    const newValue = input.value.replace(safeUpperRegex, char => {
      if (char === 'ß') return 'SS'; // Standard German uppercase conversion for ß
      return char.toUpperCase();
    });

    if (newValue !== input.value) {
        input.value = newValue;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        try { input.setSelectionRange(start, end); } catch (err) {}
    }
  }

  // ===============================
  // 3. MAX LENGTH & VISUAL FEEDBACK
  // ===============================
  if (input.value.length > maxLength) {
    console.log("⚠️ Max length exceeded, trimming");
    input.value = input.value.substring(0, maxLength);
  }

  if (input.value.length >= maxLength) {
    console.log("🚫 Max length reached");
    input.style.color = "red";
    setTimeout(() => { input.style.color = ""; }, 200);
  }

  // Reset flag after processing
  lastInputWasKeyboard = false;
}

// ===============================
// ATTACH INPUT EVENTS
// ===============================
if (isSiliconeProduct()) {
  siliconeInputs.forEach(input => {
    console.log("🔌 Attaching events to:", input.id);

    input.addEventListener('input', handleSiliconeInput);

    input.addEventListener('keydown', function(e) {
      const max = parseInt(this.getAttribute("maxlength"), 10) || 16;
      const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];

      if (this.value.length >= max && !allowed.includes(e.key) && !e.ctrlKey && !e.metaKey) {
        console.log("🚫 Prevent typing, max reached");
        this.style.color = "red";
        setTimeout(() => { this.style.color = ""; }, 200);
      }
    });

    input.addEventListener('focus', function() {
      lastFocusedInput = this;
      console.log("🎯 Focus set manually:", this.id);
    });
  });
}

// ===============================
// ICON INSERTION
// ===============================

const excludedIconInputs = [
  'fabric-text-line-1-no-qr',
  'fabric-text-line-2-no-qr',
  'fabric-text-line-3-no-qr',
  'fabric-text-line-4-no-qr'
];

document.querySelectorAll('#medical-icons-keyboard button, #fun-icons-keyboard button').forEach(button => {
  button.type = "button";

  button.addEventListener('click', function (event) {
    event.preventDefault();

    const value = button.dataset.value || button.textContent.trim();
    console.log("🧩 Icon clicked:", value);

    if (!value) return;

    const target = lastFocusedInput;
    console.log("➡️ Target input:", target ? target.id : "NONE");

    if (!target || target.disabled || target.readOnly) {
      console.log("⛔ Invalid target");
      return;
    }

    if (excludedIconInputs.includes(target.id)) {
      console.log("⛔ Icon insertion disabled for this specific field:", target.id);
      return; 
    }

    // ❗ IMPORTANT
    lastInputWasKeyboard = false;

    insertAtCaret(target, value);

    const max = parseInt(target.getAttribute("maxlength"), 10) || 16;
    if (target.value.length >= max) {
      console.log("🚫 Max reached after icon insert: ", target);
      target.style.color = "red";
      setTimeout(() => { target.style.color = ""; }, 200);
    }

    // target.dispatchEvent(new Event('input', { bubbles: true }));

    try { target.focus(); } catch (e) {}
  });
});

// ===============================
// INSERT FUNCTION
// ===============================
function insertAtCaret(target, text) {
  try {
    const supportsSelection = typeof target.selectionStart === 'number' && typeof target.selectionEnd === 'number';
    
    // --- FIXED: Get max from attribute ---
    const maxAttr = target.getAttribute("maxlength");
    const max = maxAttr ? parseInt(maxAttr, 10) : 16;

    if (supportsSelection) {
      const start = target.selectionStart;
      const end = target.selectionEnd;
      const before = target.value.slice(0, start);
      const after = target.value.slice(end);

      let insertText = text;
      // Calculate how much space is actually left
      const available = Math.max(0, max - (before.length + after.length));
      
      if (available <= 0) return; // Don't insert anything if full
      if (insertText.length > available) insertText = insertText.slice(0, available);

      target.value = before + insertText + after;
      const newPos = start + insertText.length;
      target.setSelectionRange(newPos, newPos);
    } else {
      let appendText = text;
      const available = Math.max(0, max - target.value.length);
      if (available <= 0) return;
      if (appendText.length > available) appendText = appendText.slice(0, available);
      target.value += appendText;
    }
  } catch (err) {
    console.error("Insert error:", err);
  }
}

// ===============================
// SIZE BASED MAX LENGTH
// ===============================
// ===============================
// SIZE BASED MAX LENGTH (UPDATED & SYNCED)
// ===============================
function updateSiliconeUI() {
  console.log("🔄 Updating silicone UI and Syncing Preview");

  const activeInput = document.querySelector('.product-form__input--pill input:checked, .product-form__input input:checked');
  
  if (!activeInput) return;

  const val = activeInput.value;
  const mainDiv = document.querySelector(".live-preview-overlay");

  let newLength = 16;

  if (val.includes('13')) newLength = mainDiv.getAttribute('size-13') || 16;
  else if (val.includes('14')) newLength = mainDiv.getAttribute('size-14') || 16;
  else if (val.includes('15')) newLength = mainDiv.getAttribute('size-15') || 16;
  else if (val.includes('16')) newLength = mainDiv.getAttribute('size-16') || 16;
  else if (val.includes('18')) newLength = mainDiv.getAttribute('size-18') || 18;
  else if (val.includes('20')) newLength = mainDiv.getAttribute('size-20') || 20;

  siliconeLabels.forEach(label => {
    if (label) {
      label.textContent = label.textContent.replace(/\b[1-9][0-9]\b/, newLength);
    }
  });

  siliconeInputs.forEach(input => {
    let currentVal = input.value;
    input.setAttribute('maxlength', newLength);

    // 1. Text trim logic
    if (currentVal.length > newLength) {
        input.value = currentVal.substring(0, newLength);
    }

    input.dispatchEvent(new Event('input', { bubbles: true }));
    
    console.log(`Updated ${input.id}: Length ${newLength}`);
  });
}

// Emojy Delete 
document.addEventListener('DOMContentLoaded', function() {
    const engravingInputs = document.querySelectorAll('#silicone-text-1, #silicone-text-2, #fabric-text-icons-1-no-qr, #fabric-text-line-1-no-qr, #fabric-text-line-2-no-qr, #fabric-text-line-3-no-qr, #fabric-text-line-4-no-qr');

    engravingInputs.forEach(input => {
        // Universal Emoji Regex jo har tarah ke emoji ko pakad lega
        const emojiRegex = /\p{Emoji_Presentation}|\p{Extended_Pictographic}/gu;

        const cleanInput = (el) => {
            const originalValue = el.value;
            
            // 🔥 FIXED: Replace karte waqt check karein, agar hamare custom 3 icons hain to unhein delete na karein
            const newValue = originalValue.replace(emojiRegex, (match) => {
                if (['©', '®', '™'].includes(match)) {
                    return match; // Hamare icon ko safe rakho
                }
                return ''; // Baqi asli emojis ko delete kar do
            });

            if (originalValue !== newValue) {
                el.value = newValue;

                // Red border dikhana
                el.style.border = "2px solid red";
                setTimeout(() => {
                    el.style.border = "";
                }, 2000);
            }
        };

        // Emoji ko enter hone se pehle hi rokne ke liye
        input.addEventListener('beforeinput', (e) => {
            if (e.data && emojiRegex.test(e.data)) {
                e.preventDefault();
                
                input.style.border = "2px solid red";
                setTimeout(() => {
                    input.style.border = "";
                }, 2000);
            }
        });

        input.addEventListener('input', () => cleanInput(input));
    });
    
    // const interval = setInterval(() => {
    //   const volumeContainer = document.querySelector(".ia-deal-block");
    //   const targetButtons = document.querySelector(".product-form__buttons");

    //   if (volumeContainer && targetButtons) {
    //     targetButtons.parentNode.insertBefore(volumeContainer, targetButtons);
    //     volumeContainer.style.display = 'block';
    //   }

    //   if (volumeContainer) {
    //     setTimeout(() => {
    //       clearInterval(interval);
    //     }, 1000);
    //   }
    // }, 300);
});

// Varient select aleart code start 

const addToCartButton = document.querySelector('.product-form__submit'); 

if (addToCartButton) {
  addToCartButton.addEventListener('click', function(e) {
      
      let radios = document.querySelectorAll('variant-selects input[type="radio"]');
      
      if (radios.length > 0) {
          let noneChecked = Array.from(radios).every(radio => !radio.checked);

          if (noneChecked) {
              e.preventDefault();           
              e.stopImmediatePropagation(); 
              
              alert(window.translations ? window.translations.chooseSize : 'Kies uw maat'); 
              
              let variantSelects = document.querySelector('variant-selects');
              if (variantSelects) {
                  variantSelects.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  variantSelects.classList.add("highlighted");
                  setTimeout(() => { variantSelects.classList.remove("highlighted"); }, 1000);
              }
          }
      }
  }, true);
} 

// Varient select aleart code start 

// ================= FAST BUNDLE functionality ===================//

(function() {
    const interval = setInterval(() => {
        // 1. Target the elements
        const volumeContainer = document.getElementById("rbr-container-element-volume");
        const targetButtons = document.querySelector(".product-form__buttons");
        
        // 2. Select the specific elements that have the unwanted inline 'display: none'
        // Add any additional IDs or classes from your screenshot here
        const elementsToClean = document.querySelectorAll(
            ".btns-row, #custom-fields-cont div, #medical-icons-keyboard, #qr-code-phone-generator, #qr-code-text-line-cont, #fabric-icon-text-no-qr-cont, #fabric-text-only-no-qr-cont"
        );

        // 3. Move the volume container if both elements exist
        if (volumeContainer && targetButtons) {
            // Check if it's already moved to prevent repetitive DOM manipulation
            if (volumeContainer.nextElementSibling !== targetButtons) {
                targetButtons.parentNode.insertBefore(volumeContainer, targetButtons);
                volumeContainer.style.display = 'block'; // Ensure it's visible
                console.log("✅ Volume container moved above buttons.");
            }
        }

        // 4. Remove inline 'display: none' from the cleaned elements
        if (elementsToClean.length > 0) {
            elementsToClean.forEach(el => {
                // Check if style attribute exists and contains 'none'
                if (el.getAttribute("style") && el.getAttribute("style").includes("display: none")) {
                    el.style.display = ""; // Clears the inline style
                    console.log("🧹 Cleaned inline style from:", el.id || el.className);
                    volumeContainer.style.display = 'block';
                }
            });
        }

        // Optional: Stop the interval after 10 seconds to save performance
        // if the elements are already found and processed
        // setTimeout(() => clearInterval(interval), 10000); 

    }, 300); // Runs every 300ms
})();

